import { Vector3, Quaternion, Matrix4 } from 'three';
import IPlacement3d from '../interfaces/IPlacement3d';
import { getScaledVector3 } from '../utils/scaler';

export default class Placement3d implements IPlacement3d {
    location: Vector3;
    refDirection: Vector3;
    axis: Vector3;

    constructor(location?: Vector3, refDirection?: Vector3, axis?: Vector3) {
        
            this.location = location ?? new Vector3();
            this.refDirection = refDirection ?? new Vector3(1,0,0);
            this.axis = axis ?? new Vector3(0,0,1);
    }
    
    getRotationQuaternion(): Quaternion {
        // Calculate the Y-axis as the cross product of Z (axis) and X (refDirection)
        const yAxis = new Vector3().crossVectors(this.axis, this.refDirection).normalize();

        // Create a rotation matrix from the three axes
        const rotationMatrix = new Matrix4();
        rotationMatrix.makeBasis(this.refDirection, yAxis, this.axis); // X = refDirection, Y = yAxis, Z = axis
    
        // Convert the rotation matrix to a quaternion
        const quaternion = new Quaternion();
        quaternion.setFromRotationMatrix(rotationMatrix);

        return quaternion;
    }

    clone() : IPlacement3d {
        return new Placement3d(this.location.clone(), this.refDirection.clone(), this.axis.clone());
    }

    static fromJSON(json: any): Placement3d {

        // TODO: Add validation using zod?

        const p = new Placement3d(  getScaledVector3(json.location),
                                    new Vector3(json.refDirection.x, json.refDirection.y, json.refDirection.z),
                                    new Vector3(json.axis.x, json.axis.y, json.axis.z));       
                                    
        return p;
    }

    static origo(): Placement3d {

        const p = new Placement3d();
        p.location = new Vector3(0,0,0);
        p.refDirection = new Vector3(1,0,0);
        p.axis = new Vector3(0,0,1);
        return p;
    }
}